var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"reset-success-container"},[_c('div',{staticClass:"success-box"},[_vm._m(0),_c('h2',[_vm._v("密码重置成功")]),_c('p',{staticClass:"tip-text"},[_vm._v("请妥善保管您的账户信息")]),_c('button',{staticClass:"back-btn",on:{"click":_vm.backToLogin}},[_vm._v("返回登录")])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"success-icon"},[_c('i',{staticClass:"icon-check"})])
}]

export { render, staticRenderFns }